// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp-modal-text {
    text-align: left;
}

.otp-modal-text h1 {
    margin-bottom: 1.2rem;
}

.otp-modal-content {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
    padding: 0rem 2rem;
}

.otp-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.otp-modal {
    display: flex;
    flex-direction: column;
    gap: 7rem;
    background: #fff;
    padding: 5rem;
    border-radius: 12px;
    max-width: 700px;
    width: 100%;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
}


.otp-modal-text p {
    text-align: left;
    font-size: 1.6rem;
}

.verification-text {
    text-align: left;
    font-size: 1.6rem;
}

.otp-input-group {
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin-bottom: 1rem;
}

.otp-input {
    width: 60px;
    height: 60px;
    font-size: 1.5rem;
    text-align: center;
    border: 1.5px solid #474747;
    border-radius: 12px;
}

.otp-input:focus {
    outline: none;
    border-color: #002974;
}


.otp-error {
    color: red;
    margin-bottom: 1rem;
}


.otp-button-group {
    width: 100%;
    margin-top: 3rem;
}

.otp-button {
    padding: 10px 0;
    border-radius: 6px;
    font-size: 1rem;
    cursor: pointer;
    font-weight: 600;
    border: none;
    transition: all 0.2s;
}
.user-email{
    font-weight: 600;
}
.otp-button.primary {
    width: 100%;
    padding: 12px 0;
    font-size: 1.6rem;
    background-color: #002974;
    color: white;
}

.otp-button.primary:hover {
    background-color: #001d56;
}

.resend-container {
    text-align: center;
}

.resend-button {
    background: none;
    border: none;
    font-size: 1.6rem;
    color: #002974;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
}

.resend-button:hover {
    color: #001d56;
}

.resend-timer {
    font-weight: 600;
    color: #666;
}

.resend-timer span {
    font-weight: normal;
    color: #666;
}

.loader-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #ccc;
    border-top: 4px solid #002974;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 1rem auto;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@media(max-width:768px) {
    .otp-modal {
        max-width: 530px;
    }

    .otp-modal-content {
        padding: 0 1rem;
    }
}

@media(max-width:550px) {
    .otp-modal {
        width: 90%;
    }

    .otp-modal-content {
        padding: 0;
    }

    .otp-input {
        width: 40px;
        height: 40px;
        border-radius: 8px;
    }

    .otp-modal {
        padding: 3rem;
    }
}

@media(max-width:325px) {
    .otp-input {
        width: 36px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/FormComponents/OtpVerificationModal.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,yCAAyC;IACzC,kBAAkB;AACtB;;;AAGA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;;AAGA;IACI,UAAU;IACV,mBAAmB;AACvB;;;AAGA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".otp-modal-text {\n    text-align: left;\n}\n\n.otp-modal-text h1 {\n    margin-bottom: 1.2rem;\n}\n\n.otp-modal-content {\n    display: flex;\n    flex-direction: column;\n    gap: 2.5rem;\n    padding: 0rem 2rem;\n}\n\n.otp-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.45);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.otp-modal {\n    display: flex;\n    flex-direction: column;\n    gap: 7rem;\n    background: #fff;\n    padding: 5rem;\n    border-radius: 12px;\n    max-width: 700px;\n    width: 100%;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n    text-align: center;\n}\n\n\n.otp-modal-text p {\n    text-align: left;\n    font-size: 1.6rem;\n}\n\n.verification-text {\n    text-align: left;\n    font-size: 1.6rem;\n}\n\n.otp-input-group {\n    display: flex;\n    justify-content: space-between;\n    align-items: start;\n    margin-bottom: 1rem;\n}\n\n.otp-input {\n    width: 60px;\n    height: 60px;\n    font-size: 1.5rem;\n    text-align: center;\n    border: 1.5px solid #474747;\n    border-radius: 12px;\n}\n\n.otp-input:focus {\n    outline: none;\n    border-color: #002974;\n}\n\n\n.otp-error {\n    color: red;\n    margin-bottom: 1rem;\n}\n\n\n.otp-button-group {\n    width: 100%;\n    margin-top: 3rem;\n}\n\n.otp-button {\n    padding: 10px 0;\n    border-radius: 6px;\n    font-size: 1rem;\n    cursor: pointer;\n    font-weight: 600;\n    border: none;\n    transition: all 0.2s;\n}\n.user-email{\n    font-weight: 600;\n}\n.otp-button.primary {\n    width: 100%;\n    padding: 12px 0;\n    font-size: 1.6rem;\n    background-color: #002974;\n    color: white;\n}\n\n.otp-button.primary:hover {\n    background-color: #001d56;\n}\n\n.resend-container {\n    text-align: center;\n}\n\n.resend-button {\n    background: none;\n    border: none;\n    font-size: 1.6rem;\n    color: #002974;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 0;\n}\n\n.resend-button:hover {\n    color: #001d56;\n}\n\n.resend-timer {\n    font-weight: 600;\n    color: #666;\n}\n\n.resend-timer span {\n    font-weight: normal;\n    color: #666;\n}\n\n.loader-spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid #ccc;\n    border-top: 4px solid #002974;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin: 1rem auto;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@media(max-width:768px) {\n    .otp-modal {\n        max-width: 530px;\n    }\n\n    .otp-modal-content {\n        padding: 0 1rem;\n    }\n}\n\n@media(max-width:550px) {\n    .otp-modal {\n        width: 90%;\n    }\n\n    .otp-modal-content {\n        padding: 0;\n    }\n\n    .otp-input {\n        width: 40px;\n        height: 40px;\n        border-radius: 8px;\n    }\n\n    .otp-modal {\n        padding: 3rem;\n    }\n}\n\n@media(max-width:325px) {\n    .otp-input {\n        width: 36px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
